
    var riot = require('riot')
    //src: starling/src/tags/menu/buttons/menu-button-delete-region.html
riot.tag2('menu-button-delete-region',
  '<svg class="bulk-actions-menu-item_icon"> <use xlink:href="#delete-icon"></use> </svg>',
  '',
  'class="bulk-actions-menu-item" data-tip="Delete region" onclick="{deleteSelf}"', function(opts) {
'use strict';

var _regionUi = require('lib/region-ui');

var _opts = opts,
    canvas = _opts.canvas;

this.deleteSelf = function () {
  _regionUi.regionUI.deleteRegions({ ids: _regionUi.regionUI.getSelectedRegionIds() });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-button-delete-region')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/buttons/menu-button-delete-region.html
// module id = 746
// module chunks = 0